export const CUSTOMER_PORTAL_LOCKOUT_HOUR_OPTIONS = [12, 24, 48, 72];

export const CUSTOMER_PORTAL_SETTING_DEFAULTS = {
  module_enabled: false,
  allow_client_edit: true,
  allow_client_cancel: true,
  allow_client_reschedule: true,
  waitlist_enabled: true,
  social_login_enabled: false,
  client_change_lockout_enabled: false,
  client_change_lockout_hours: 24,
};

const BOOLEAN_SETTING_KEYS = [
  "module_enabled",
  "allow_client_edit",
  "allow_client_cancel",
  "allow_client_reschedule",
  "waitlist_enabled",
  "social_login_enabled",
  "client_change_lockout_enabled",
];

const settingBoolean = (value, fallback) => {
  if (value === false || value === 0 || value === "0" || value === "false") return false;
  if (value === true || value === 1 || value === "1" || value === "true") return true;
  return fallback;
};

export const getCustomerPortalSettings = (settings) => {
  let parsed = settings;
  if (typeof settings === "string") {
    try {
      parsed = JSON.parse(settings);
    } catch (error) {
      parsed = {};
    }
  }
  const merged = {
    ...CUSTOMER_PORTAL_SETTING_DEFAULTS,
    ...(parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {}),
  };
  const normalized = {};
  BOOLEAN_SETTING_KEYS.forEach((key) => {
    normalized[key] = settingBoolean(merged[key], CUSTOMER_PORTAL_SETTING_DEFAULTS[key]);
  });
  const hours = Number(merged.client_change_lockout_hours);
  normalized.client_change_lockout_hours = CUSTOMER_PORTAL_LOCKOUT_HOUR_OPTIONS.includes(hours)
    ? hours
    : CUSTOMER_PORTAL_SETTING_DEFAULTS.client_change_lockout_hours;
  return normalized;
};

export const isCustomerPortalSettingEnabled = (settings, key) => {
  const normalized = getCustomerPortalSettings(settings);
  return key === "module_enabled"
    ? normalized.module_enabled
    : normalized.module_enabled && normalized[key] === true;
};

export const isCustomerPortalModuleEnabled = (settings) =>
  isCustomerPortalSettingEnabled(settings, "module_enabled");

// The public booking widget offers the waitlist only when the Customer Portal
// module AND the waitlist setting are both on, exactly like the Laravel widget
// (isCustomerPortalSettingEnabled(settings, "waitlist_enabled")).
export const waitlistEnabledForPublicBooking = (settings) =>
  isCustomerPortalSettingEnabled(settings, "waitlist_enabled");

